import React from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

import { filter, forEach, get } from 'lodash-es';

const ValidationMessage = ({ validate, path }) => {
  const messages = [];
  const msg = get(validate, `${path}.messages`);
  const warnings = filter(msg, { type: 'warning' });
  const errors = filter(msg, { type: 'error' });

  forEach(warnings, (warning, idx) => {
    messages.push(
      <div className={cn('warning validation-message', path)} key={`valid-msg-${idx}`}>
        {get(warning, 'message')}
      </div>
    );
  });

  forEach(errors, (error, idx) => {
    messages.push(
      <div className={cn('error validation-message', path)} key={`valid-msg-${idx}`}>
        {get(error, 'message')}
      </div>
    );
  });
  return messages;
};

ValidationMessage.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  validate: PropTypes.object,
  path: PropTypes.string.isRequired,
};

ValidationMessage.defaultProps = {
  validate: {},
};

export default ValidationMessage;
